import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteScopedSchedule = api(async function deleteScopedSchedule({ projectId, scheduleId }) {
    if (!projectId && !scheduleId) return null
    return mutate(
        gql`
            mutation DeleteScopedSchedule($projectId: String!, $scheduleId: String!) {
                deleteScopedSchedule(projectId: $projectId, scheduleId: $scheduleId)
            }
        `,
        { projectId, scheduleId },
        { returns: "deleteScopedSchedule" }
    )
})
